/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IamRolePermission
 */
export interface IamRolePermission {
    /**
     * 
     * @type {string}
     * @memberof IamRolePermission
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamRolePermission
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IamRolePermission
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamRolePermission
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IamRolePermission
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof IamRolePermission
     */
    roleId?: string;
    /**
     * 
     * @type {string}
     * @memberof IamRolePermission
     */
    permissionId?: string;
    /**
     * 
     * @type {string}
     * @memberof IamRolePermission
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamRolePermission
     */
    statusDate?: Date;
}

export function IamRolePermissionFromJSON(json: any): IamRolePermission {
    return IamRolePermissionFromJSONTyped(json, false);
}

export function IamRolePermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): IamRolePermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'updatedBy': !exists(json, 'updated_by') ? undefined : json['updated_by'],
        'roleId': !exists(json, 'role_id') ? undefined : json['role_id'],
        'permissionId': !exists(json, 'permission_id') ? undefined : json['permission_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDate': !exists(json, 'status_date') ? undefined : (new Date(json['status_date'])),
    };
}

export function IamRolePermissionToJSON(value?: IamRolePermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'updated_by': value.updatedBy,
        'role_id': value.roleId,
        'permission_id': value.permissionId,
        'status': value.status,
        'status_date': value.statusDate === undefined ? undefined : (value.statusDate.toISOString()),
    };
}


